import React from 'react';

import { useState } from 'react';
import { useToasts } from 'react-toast-notifications';

import Form from './Form';
import { SModal, SModalBody, Title, Background, Back } from './styled';
import ErrorBlock from './ErrorBlock';
import { signIn } from '../../../firebase/api/auth';
import { createUser } from '../../../firebase/api/user';

const getAuthError = (e: string, login: string) => {
  if (e === 'Error: FirebaseError: Firebase: Error (auth/user-not-found).')
    return `Пользователь с таким логином не найден`;
  if (e === 'Error: FirebaseError: Firebase: Error (auth/wrong-password).')
    return `Неверный пароль`;
  if (e === 'Error: FirebaseError: Firebase: Error (auth/email-already-in-use).')
    return `Пользователь с логином ${login} уже существует`;
  if (
    e ===
    'Error: FirebaseError: Firebase: Password should be at least 6 characters (auth/weak-password).'
  )
    return `Пароль должен состоять минимум из 6-ти символов`;
  if (e === 'Error: FirebaseError: Firebase: Error (auth/invalid-email).') {
    return `Введите корректный E-mail адрес`;
  }
  return 'Не удалось авторизоваться, попробуйте еще раз';
};

const Login: React.FC<{
  setIsRegister: (isReg: boolean) => void;
  isRegister: boolean;
  back: () => void;
}> = (props) => {
  const { addToast } = useToasts();
  const [login, setLogin] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.name === 'login' ? setLogin(e.target.value) : setPassword(e.target.value);
  };

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      props.isRegister ? await createUser(login, password) : await signIn(login, password);
    } catch (e) {
      console.log(e);
      addToast(getAuthError(`${e}`, login), {
        appearance: 'error',
      });
      setIsError(true);
    }
    setIsLoading(false);
  };

  return (
    <Background>
      <SModal>
        <SModalBody>
          <Title>
            <Back onClick={props.back}>←</Back>
            {props.isRegister ? 'Регистрация' : 'Вход'}
          </Title>
          <Form
            submit={submit}
            isLoading={isLoading}
            login={login}
            password={password}
            onChange={onChange}
            submitText={props.isRegister ? 'Зарегистрироваться' : 'Войти'}
            isRegister={props.isRegister}
            setIsRegister={props.setIsRegister}
          />
        </SModalBody>
        <ErrorBlock isVisible={isError} onClose={() => setIsError(false)} />
      </SModal>
    </Background>
  );
};

export default Login;
